var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefund({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.416,
    height: 49.125,
    viewBox: "0 0 48.416 49.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{stroke:#000;stroke-width:.4px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refund",
    transform: "translate(.001 .2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M47 0a22.842 22.842 0 0 0-22.8 22.8 18.066 18.066 0 0 0 .08 2.08l1.6-.16a15.4 15.4 0 0 1-.08-1.92 21.2 21.2 0 1 1 22 21.2l1.76-1.76-1.12-1.12-3.76 3.76 3.76 3.76 1.12-1.12-1.92-1.92A22.806 22.806 0 0 0 47 0zm0 0",
    className: "cls-1",
    "data-name": "Path 4",
    transform: "translate(-21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M141 96h-28.8v14.4H141zm-1.6 12.8h-25.6V97.6h25.6zm0 0",
    className: "cls-1",
    "data-name": "Path 5",
    transform: "translate(-100.799 -86.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M227.4 142.4a3.2 3.2 0 1 0-3.2-3.2 3.209 3.209 0 0 0 3.2 3.2zm0-4.8a1.6 1.6 0 1 1-1.6 1.6 1.6 1.6 0 0 1 1.6-1.6zm0 0",
    className: "cls-1",
    "data-name": "Path 6",
    transform: "translate(-201.599 -122.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M145.8 129.6h1.6V128h-3.2v3.2h1.6zm0 0",
    className: "cls-1",
    "data-name": "Path 7",
    transform: "translate(-129.599 -115.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M147.4 177.6h-1.6V176h-1.6v3.2h3.2zm0 0",
    className: "cls-1",
    "data-name": "Path 8",
    transform: "translate(-129.599 -158.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M339.4 176h-1.6v1.6h-1.6v1.6h3.2zm0 0",
    className: "cls-1",
    "data-name": "Path 9",
    transform: "translate(-302.398 -158.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M337.8 131.2h1.6V128h-3.2v1.6h1.6zm0 0",
    className: "cls-1",
    "data-name": "Path 10",
    transform: "translate(-302.398 -115.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M184.2 160h2.4v1.6h-2.4zm0 0",
    className: "cls-1",
    "data-name": "Path 11",
    transform: "translate(-165.599 -143.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M304.2 160h2.4v1.6h-2.4zm0 0",
    className: "cls-1",
    "data-name": "Path 12",
    transform: "translate(-273.598 -143.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M48.2 344h1.6v2.4h-1.6zm0 0",
    className: "cls-1",
    "data-name": "Path 13",
    transform: "translate(-43.2 -309.598)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M40.2 268.879a3.005 3.005 0 0 0-2.96-2.96 2.73 2.73 0 0 0-.8.08l-9.681 2.8c-.08 0-.24.08-.32 0l-2.24-.4a3.263 3.263 0 0 0 1.28-4.32 3.14 3.14 0 0 0-2.8-1.68H12.6a2.256 2.256 0 0 0-1.2.32l-1.6 1.04v-1.2H.2v13.6h9.6v-2l7.92 3.28a2.218 2.218 0 0 0 1.6.08l18.721-5.841a2.837 2.837 0 0 0 2.159-2.799zm-32 5.68H1.8v-10.4H5v4.8h1.6v-4.8h1.6zM18.92 276a.682.682 0 0 1-.56 0l-8.56-3.6v-6.8l2.4-1.36a.6.6 0 0 1 .4-.08h10a1.6 1.6 0 1 1 0 3.2H17v.8l-.16.8 9.2 1.52a2.3 2.3 0 0 0 1.04-.08l9.681-2.8a1.366 1.366 0 0 1 1.68.96 1.319 1.319 0 0 1-.88 1.68zm0 0",
    className: "cls-1",
    "data-name": "Path 14",
    transform: "translate(0 -236.157)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.b1dbe4bd.svg";
export { ForwardRef as ReactComponent };